import { IExternalAgent } from "./IExternalAgent";

interface IProps {
  agent: IExternalAgent;
  handleChange: (field: string, value: boolean) => void;
}

const KPIsList = [
  "adl",
  "best_booker",
  "best_sel",
  "cancelation_ratio",
  "professional",
  "amateur",
  "beginner",
  "group_d",
  "group_e",
  "group_f",
];

const KPIs = ({ agent, handleChange }: IProps) => {
  return (
    <>
      KPIs
      <hr />
      {KPIsList.map((kpiKey: string, index: number) => {
        return (
          <div key={index}>
            <input
              type="checkbox"
              checked={agent[kpiKey as keyof IExternalAgent] as boolean}
              onChange={(e) => {
                handleChange(kpiKey, e.target.checked);
              }}
            />
            <span>
              {kpiKey.charAt(0).toUpperCase() +
                kpiKey.slice(1).replace(/_/g, " ")}
            </span>
          </div>
        );
      })}
    </>
  );
};

export default KPIs;
